module.exports = __webpack_public_path__ + "img/cnd.ca2d1910.svg";